import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCECJOF4QhnagHGoaVo_Whn5nX-3fuTnbs",
    authDomain: "refrigeration-9e407.firebaseapp.com",
    projectId: "refrigeration-9e407",
    storageBucket: "refrigeration-9e407.firebasestorage.app",
    messagingSenderId: "694208129682",
    appId: "1:694208129682:web:05459cb3db33bb5868d44b",
    measurementId: "G-P9L04BYMT0"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);